export const safeJSON = {
  fromString<T extends object = any>(
    value: string | undefined | null,
    reviver?: (this: any, key: string, value: any) => any,
    onError?: (error: unknown) => void
  ): T | null {
    try {
      if (typeof value === 'string') {
        return JSON.parse(value, reviver);
      }
      return null;
    } catch (e) {
      onError?.(e);
      return null;
    }
  },
  toString(
    value: unknown,
    replacer?: null | ((this: any, key: string, value: any) => any),
    space?: string | number
  ): string {
    return JSON.stringify(value, replacer ?? undefined, space);
  }
};
